import React from 'react'
import './congrats-modal.css'
const CongratsModal = ({setCongratsModal}) => {
    const [randomGiph, setRandomGiph] = React.useState('')

    React.useEffect(() => {
        setRandomGiph(giphs[chooseRandomNumber(7)])
    }, [])

    const chooseRandomNumber = (max) => {
        return Math.floor(Math.random() * max)
    }

    const close = (id) => {
        if(id === 'congrats-modal__wrapper') {
            setCongratsModal(false)
        }
    }

    const giphs = [
        "https://media.giphy.com/media/ely3apij36BJhoZ234/giphy.gif?cid=790b7611og1udlzqecx8ma5wfxb768n3kj3d33cxvgtivn0w&ep=v1_gifs_search&rid=giphy.gif&ct=g", 
        "https://media.giphy.com/media/kAUtsLfsEfqaJRwe80/giphy.gif?cid=790b7611og1udlzqecx8ma5wfxb768n3kj3d33cxvgtivn0w&ep=v1_gifs_search&rid=giphy.gif&ct=g",
        "https://media.giphy.com/media/111ebonMs90YLu/giphy.gif?cid=790b7611og1udlzqecx8ma5wfxb768n3kj3d33cxvgtivn0w&ep=v1_gifs_search&rid=giphy.gif&ct=g",
        "https://media.giphy.com/media/wijMRo7UZXSqA/giphy.gif?cid=ecf05e47z05sw48r1njwtr9fhhot5q0z0hrupjjx897r1uu8&ep=v1_gifs_search&rid=giphy.gif&ct=g",
        "https://media.giphy.com/media/Mp4hQy51LjY6A/giphy.gif?cid=790b7611epkvhrotzccrwavkse0q7q94o2jfjhtk295d4b5o&ep=v1_gifs_search&rid=giphy.gif&ct=g",
        "https://media.giphy.com/media/roIRm9blot1UQ/giphy.gif?cid=790b7611hwj5ln1jeydbpk3kq3yd4zmje7ohs1n0b0324yd4&ep=v1_gifs_search&rid=giphy.gif&ct=g",
        "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExdnZ5c3k4dWRjcGNzMW92cnFycDBnZTZ0YWdmcjl2bWQ3czQydDJxZiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/QsU3vYYHB69R3bvBMK/giphy.gif",
        "https://media.giphy.com/media/jJQC2puVZpTMO4vUs0/giphy.gif?cid=790b7611z4mrqcb5mso6d0qui7ng4cfsglz8cptoixh6bkmp&ep=v1_gifs_search&rid=giphy.gif&ct=g"
    ]
    return (
        <div className='congrats-modal__wrapper' id='congrats-modal__wrapper' onClick={(e) => close(e.target.id)}>
            <div className='congrats-modal'>
                <div className='congrats-modal__title'>🎉YAY!🎉</div>
                <img className='congrats-modal__giph' alt="giph1" src={randomGiph} />
            </div>
        </div>
    )
}
export default CongratsModal;